<template>
  <div class="column-edit-size">
    <el-input-number
      v-model="sizeLength"
      :controls="false"
      :precision="precision"
      :min="min"
      :max="max"
      size="mini"
      data-index="sizeLength"
      @change="handleChange"
    />
    <span>*</span>
    <el-input-number
      v-model="sizeWidth"
      :controls="false"
      :precision="precision"
      :min="min"
      :max="max"
      size="mini"
      data-index="sizeWidth"
      @change="handleChange"
    />
    <span>*</span>
    <el-input-number
      v-model="sizeHeight"
      :controls="false"
      :precision="precision"
      :min="min"
      :max="max"
      size="mini"
      data-index="sizeHeight"
      @change="handleChange"
    />
  </div>
</template>

<script>
import Vue from 'vue'
export default Vue.extend({
  name: 'CargoAgGridColumnEditGroup',
  data() {
    return {
      custom: null,
      valueChanged: null,
      sizeLength: 0,
      sizeWidth: 0,
      sizeHeight: 0,
      precision: undefined,
      min: undefined,
      max: undefined
    }
  },
  created() {
    this.custom = this.params
    this.sizeLength = this.custom.data.sizeLength
    this.sizeWidth = this.custom.data.sizeWidth
    this.sizeHeight = this.custom.data.sizeHeight
    this.valueChanged = this.custom.valueChanged
    this.precision = this.custom.precision
    this.min = this.custom.min
    this.max = this.custom.max
  },
  methods: {
    handleChange() {
      this.custom.data.sizeLength = this.sizeLength
      this.custom.data.sizeWidth = this.sizeWidth
      this.custom.data.sizeHeight = this.sizeHeight
      this.valueChanged(this.custom)
    }
  }
})
</script>

<style lang="scss">
.column-edit-size{
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  box-sizing: border-box;
  padding: 1px 10px;
  .el-input--mini .el-input__inner {
    height: 21px!important;
  }
  span{
    height: 24px;
    line-height: 30px;
    font-size: 18px;
  }
  .ag-grid-column-edit{
    .el-input--mini .el-input__inner {
      height: 23px!important;
    }
  }
}
</style>
